<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="8" cy="8" r="3"/>
    <path d="M8 1v2"/><path d="M8 13v2"/>
    <path d="M13 8h2"/><path d="M1 8h2"/>
    <path d="M11.5 11.5l1.4 1.4"/><path d="M3.1 3.1l1.4 1.4"/>
    <path d="M11.5 4.5l1.4-1.4"/><path d="M3.1 12.9l1.4-1.4"/>
  </svg>
</template>
